import { HomeSectionContent } from '@/components/HomeSectionContent';
import { SimpleHorizontalSlider } from '@/components/SimpleHorizontalSlider';
import '@/components/Skeleton/styles.scss';
import Constants from '@/Constants';
import Category from '@/models/Category';
import { ApplicationState } from '@/store';
import { getCategoriesRequest } from '@/store/category/action';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import './styles.scss';

const CategoriesSection: React.FC = () => {
    const dispatch = useDispatch();

    const { strings, categoriesState, orgId } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
        categoriesState: state.categories,
        orgId: state.appOrganization.data.organization.id,
    }));

    const renderCategoryItem = (category: Category) => {
        return (
            <NavLink
                className="category-item"
                draggable={false}
                exact
                key={`category-item-${category.id}`}
                to={`${Constants.CATEGORY}/${category.id}`}
            >
                {category.name}
            </NavLink>
        );
    };

    const renderCategoryCardSkeleton = () => {
        return (
            <div className="skeleton-categories-container skeleton-container skeleton-wave">
                {[...new Array(5)].map((_, index) => (
                    <div className="skeleton-item category-item" key={`skeleton-course-item-${index}`} style={{ minWidth: 150 }} />
                ))}
            </div>
        );
    };

    useEffect(() => {
        dispatch(
            getCategoriesRequest({
                orgId,
                onlyIfHasCourseOrContent: true,
                applicationId: Constants.APP_ID,
            }),
        );
    }, [orgId]);

    if (!categoriesState.loading && !categoriesState.data.categories.length) {
        return null;
    }

    return (
        <div className="categories-section-container">
            <HomeSectionContent title={strings.LIST_OF_CATEGORIES}>
                <SimpleHorizontalSlider>
                    {categoriesState.loading ? renderCategoryCardSkeleton() : categoriesState.data.categories.map(renderCategoryItem)}
                </SimpleHorizontalSlider>
            </HomeSectionContent>
        </div>
    );
};

export { CategoriesSection };
